export default __webpack_public_path__ + "static/media/evenShotBg.b9e33a4c.png";